module.exports = __webpack_public_path__ + "img/fdbe394143e60f14dd5648ccd7234d29.png";